export default {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL,
  VUE_APP_PER_PAGE: parseInt(process.env.VUE_APP_PER_PAGE || "10"),
  VUE_APP_TINY_EDITOR_KEY:
    process.env.VUE_APP_TINY_EDITOR_KEY ||
    "vcdaorl5z0uf3blvzjc5glybdjjszgo0c60mvaesqwi4sh2p",
};
